import userApi from "api/user";
import { Button, Col, Form, Input, Modal, Row, Tooltip } from "antd";
import { useState } from "react";
import style from "./index.module.scss";
import classNames from "classnames/bind";
import { UnlockOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";

const cx = classNames.bind(style);

export default function ModalChangePassword({ id, openNotificationWithIcon }) {
  const [openModal, setOpenModal] = useState(false);
  const [form] = Form.useForm();
  const { t } = useTranslation()

  const onFinish = async (values) => {
    try {
      await userApi.changePasswordUser(id, values);
      onCancel();
      openNotificationWithIcon("success", t('notification'), t('updatePasswordSuccess'));
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
    }
  };

  const onCancel = () => {
    setOpenModal(false);
    form.resetFields();
  };

  return (
    <>
      <Tooltip title={t('changePassword')}>
        <Button className={cx("btn-grey")} onClick={() => setOpenModal(true)}>
          <UnlockOutlined />
        </Button>
      </Tooltip>
      <Modal
        open={openModal}
        title={t('changePasswordEmployee')}
        centered
        footer={null}
        onCancel={onCancel}
        width={768}
        destroyOnClose
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item
            name="newPassword"
            label={t('newPassword')}
            required
            rules={[{ required: true }]}
          >
            <Input.Password />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label={t('confirmPassword')}
            required
            rules={[
              {
                required: true,
              },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error(t('notMatchPassword')));
                },
              }),
            ]}
          >
            <Input.Password />
          </Form.Item>
          <Row gutter={16}>
            <Col span={8} offset={4}>
              <Form.Item>
                <Button style={{ width: "100%" }} htmlType="submit">
                  Ok
                </Button>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button style={{ width: "100%" }} onClick={onCancel}>
                {t('cancel')}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}
